import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, WHATSAPP_URL } from "../lib/site";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <nav
            data-testid="main-navbar"
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
                scrolled ? "py-3 bg-[#F5F4F2]/90 backdrop-blur-md border-b border-[#B7A6B0]/30" : "py-6 bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
                <a href="#hero" data-testid="navbar-logo" className="flex items-baseline gap-2 group">
                    <span className="font-display text-2xl tracking-tight text-[#2F2F2F]">Luara Ainá</span>
                    <span className="hidden sm:inline overline text-[10px]">Psicóloga</span>
                </a>
                <div className="hidden md:flex items-center gap-9">
                    <a href="#sobre" className="text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors">Sobre</a>
                    <a href="#terapia" className="text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors">Terapia</a>
                    <a href="#casais" className="text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors">Casais</a>
                    <a href="#processo" className="text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors">Processo</a>
                    <a href="#faq" className="text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors">Perguntas</a>
                </div>
                <div className="flex items-center gap-5">
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="navbar-instagram"
                        aria-label={`Instagram ${INSTAGRAM_HANDLE}`}
                        className="hidden sm:inline-flex items-center gap-2 text-sm text-[#2F2F2F]/80 hover:text-[#9f1e1e] transition-colors"
                    >
                        <Instagram className="w-4 h-4" strokeWidth={1.5} />
                        <span className="hidden lg:inline">{INSTAGRAM_HANDLE}</span>
                    </a>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="navbar-whatsapp-cta"
                        className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-[#9f1e1e] border-b border-[#9f1e1e] pb-0.5 hover:opacity-70 transition-opacity"
                    >
                        Agendar sessão
                    </a>
                </div>
            </div>
        </nav>
    );
};
